<template>
  <div class="notification-list">
    <div class="notification-cards">
      <div v-if="notifications.length > 0">
				<ul class="p-0" style="text-align: left;padding-left:0;">
					<li v-for="notification in notifications" :key="notification.id">
						<span :class="{ 'unread': notification.status === 'unread' }">
							<div style="font-weight:600">{{ notification.title }} 
                <span v-if="notification.priority==1" style="border-radius: 10px;background-color: red;color: white;padding: 3px 8px;">Imp</span>
                <span v-if="notification.priority==2" style="border-radius: 10px;background-color: green;color: white;padding: 3px 8px;">Medium</span>
                <span v-if="notification.priority==3" style="border-radius: 10px;background-color: orange;color: white;padding: 3px 8px;">Low</span>
              </div>
							<div style="font-weight:lighter">{{ notification.body }}</div>
						</span>
						<!-- <h4>{{ notification.title }}</h4> -->
            <hr/>
					</li>
				</ul>
			</div>
			<div v-else>
				<p>No notifications available.</p>
			</div>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, onUnmounted } from 'vue';
import { useUserStore } from '@/stores/userStore';
import { useNotifications } from '@/composables/useNotifications';

export default {
  setup() {
    const userStore = useUserStore();
    const axios = inject('axios');
    const notificationStore = useNotifications(axios); // Store the entire object

    onMounted(async () => {
      notificationStore.fetchNotifications(userStore.getmca_no);
      userStore.setCount(0);
    });
    onUnmounted(async()=>{
      await notificationStore.markReadNotificationsCount();
    })
    return {
      notifications: notificationStore.notifications,
    };
  }
};
</script>

<style lang="css" scoped>
.action-buttons {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
}

.action-buttons button {
  background-color: transparent ;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
}

.action-buttons button:hover {
  /* background-color: #d3d3d3; */
}

.action-buttons button:first-child {
  /* background-color: #4CAF50; */
  /* color: white; */
}

.action-buttons button:last-child {
  /* background-color: #f44336; */
  /* color: white; */
}

.address-card{
  text-align: start;
  display: flex;
}

h2 {
  font-size: 24px;
  font-weight: bold;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #000;
  border-radius: 4px;
}

.search-bar input {
  border: none;
  flex: 1;
  font-size: 14px;
  padding: 5px;
}

.search-bar .search-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.search-icon {
  background-size: cover;
  width: 20px;
  height: 20px;
  display: inline-block;
}

.add-new-address {
  display: inline-block;
  margin-bottom: 20px;
  font-size: 14px;
  /* color: #000; */
  text-decoration: none !important;
  text-align: right;
  width: 100%;
}

.add-new-address:hover {
  text-decoration: underline;
}

.address-cards {
  display: flex;
  flex-direction: column;
}

.address-card:hover {
  background-color: #276ca5;
  color: #fff;
}
.address-card {
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.address-card.default-address {
  background-color:#276ca5;
  /* background-color:#05354d; */
  color: white !important;
  /* border-color: ; */
}

.address-card p {
  margin: 5px 0;
  font-size: 14px;
  width: 100%;
}

</style>